"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import API from "@ym-framework/api-utils";
import timeformatter from "@/framework/timeformatter";
let AutoDeleteDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.teamItem = null;
    this.dateTime = new Date(new Date().getDate() + 1);
    this.pickerOptions = {
      disabledDate(time) {
        return time.getTime() < new Date();
      }
    };
  }
  open(item) {
    try {
      this.teamItem = item;
      let today = new Date();
      let tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      this.dateTime = tomorrow;
      this.dialog.visible = true;
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  confirmDelete() {
    return __async(this, null, function* () {
      try {
        if (this.dateTime === null) {
          return;
        }
        yield UiConfirm.warnconfirm(
          this.$t("auto_delete_dialog.confirm_delete_tip"),
          this.$t("auto_delete_dialog.confirm_delete_tip_title"),
          {
            confirmButtonText: this.$t("headertoolbar.confirm"),
            cancelButtonText: this.$t("headertoolbar.cancel")
          }
        );
        let dateTime = Math.floor(new Date(this.dateTime).getTime() / 1e3);
        let showTime = timeformatter.dateformat(new Date(this.dateTime).getTime());
        let ids = [];
        ids.push(this.teamItem.guid);
        yield API.post(`api://base.auth.pro/v1/scheduled-deletion-user`, {
          userIds: ids,
          deleteTime: dateTime
        });
        this.$message.success(this.$t("auto_delete_dialog.confirm_delete_success", { "time": showTime }));
        this.close();
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  close() {
    this.dialog.visible = false;
    this.teamItem = null;
    this.dateTime = null;
  }
};
AutoDeleteDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], AutoDeleteDialog);
export {
  AutoDeleteDialog as default
};
